import { RootState } from '@app';

const isLoadingSelector = (state: RootState) => state.generic.isLoading;
const loadingTextSelector = (state: RootState) => state.generic.loadingText;
export { isLoadingSelector, loadingTextSelector };
